import { useMemo } from "react";
import { useRouter } from "next/router";

import Breadcrumb from "components/Breadcrumb";
import Breadcrumbs from "components/Breadcrumbs";

const BrandCrumbs = ({ brandName }: { brandName: string }) => {
  const router = useRouter();
  const trail = router.asPath.split("/").filter(Boolean);

  const breadcrumbTrail = useMemo(() => {
    return trail.reduce(
      (
        acc: {
          trails: {
            currentLocation?: boolean;
            href: string;
            name: string;
          }[];
          prevHref: string;
        },
        crumb: string,
        index: number
      ) => {
        const href = `${acc.prevHref}/${crumb}`;
        const isCurrentLocation = index === trail.length - 1;
        const name = isCurrentLocation ? crumb.split("?")[0] : crumb;

        acc.trails.push({
          currentLocation: isCurrentLocation,
          href,
          name:
            index === 1
              ? brandName
              : name.replace(/^\w/, (c) => c.toUpperCase()),
        });
        acc.prevHref = href;
        return acc;
      },
      { prevHref: "", trails: [] }
    ).trails;
  }, [trail]);

  return (
    <Breadcrumbs className="m-[-16px]">
      {breadcrumbTrail.map((crumb) => (
        <Breadcrumb
          href={crumb.href}
          key={crumb.name}
          currentLocation={crumb.currentLocation}
        >
          {crumb.name}
        </Breadcrumb>
      ))}
    </Breadcrumbs>
  );
};

export default BrandCrumbs;
